import {useController} from "react-hook-form";
import {CFormGroup, CLabel, CSwitch} from "@coreui/react";
import classNames from "classnames";
import ValidationFeedback from "../../ValidationFeedback";

const ARSwitch = ({control, name, id, labelText, className, labelClassName, size, variant, color, ...props}) => {
  const {field, fieldState} = useController({
    name,
    control
  });

  const {ref, value, ...switchProps} = field;
  const {error} = fieldState;

  return (
    <CFormGroup className={classNames(className)}>
      <CSwitch
        id={id}
        name={name}
        size={size}
        variant={variant}
        color={color}
        checked={value}
        {...props}
        {...switchProps}
      />
      <CLabel htmlFor={id || ""} className={classNames(labelClassName)}>
        {labelText}
      </CLabel>
      <ValidationFeedback error={error}/>
    </CFormGroup>
  );
};

ARSwitch.defaultProps = {
  size: "sm",
  variant: "3d",
  color: "primary"
};

export default ARSwitch;